import { questionTypes } from "../constants";
import { fill } from "lodash";
import { v4 as uuid } from "uuid";
import { resourceObjectTypes } from "../constants/index";

export const getNewMatchChoice = position => ({
  text: "",
  id: uuid(),
  position,
  type: resourceObjectTypes.matchChoiceType
});

export const getNewMatchClue = (position, correctMatch) => ({
  text: "",
  id: uuid(),
  position,
  type: resourceObjectTypes.matchClueType,
  relationshipNames: ["correctMatch"],
  correctMatch
});

const getIsCorrect = (questionType, answerIndex) => {
  if (questionType === questionTypes.ordering) {
    return true;
  } else if (questionType === questionTypes.multiSelect) {
    return false;
  } else {
    return answerIndex === 0;
  }
};

export const getDefaultAnswerChoices = (questionType, isSurveyQuestion, t) => {
  let answers = [];
  switch (questionType) {
    case questionTypes.trueFalse:
      answers = [
        { text: t("editQuestion.trueResponse") },
        { text: t("editQuestion.falseResponse") }
      ];
      break;
    case questionTypes.multipleChoice:
    case questionTypes.ordering:
    case questionTypes.multiSelect:
      answers = fill(new Array(4), { text: "" });
      break;
    case questionTypes.shortAnswer:
      answers = [{ text: "" }];
      break;
    default:
      break;
  }

  answers = answers.map((answer, index) => ({
    ...answer,
    order: index,
    correct: getIsCorrect(questionType, index),
    type: "answer",
    id: uuid()
  }));
  return answers;
};

export const getDefaultMatches = isSurveyQuestion => {
  const matchChoices = [getNewMatchChoice(0), getNewMatchChoice(1)];
  // we set the correct match for the first two match clues to the first two match choices
  // if the question is for a survey, we set correct match to null
  return {
    matchClues: [
      getNewMatchClue(0, !isSurveyQuestion ? matchChoices[0] : ""),
      getNewMatchClue(1, !isSurveyQuestion ? matchChoices[1] : "")
    ],
    matchChoices
  };
};
